import { render, staticRenderFns } from "./editStudentSubjectDiary.vue?vue&type=template&id=05fed7b2&scoped=true"
import script from "./editStudentSubjectDiary.vue?vue&type=script&lang=js"
export * from "./editStudentSubjectDiary.vue?vue&type=script&lang=js"
import style0 from "./editStudentSubjectDiary.vue?vue&type=style&index=0&id=05fed7b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fed7b2",
  null
  
)

export default component.exports